<template>
<div id="supp">
  <div id="mydiv" style="text-align: right;right:15px;
  z-index: 3;opacity:1;max-width:110px;background: #00947e;
    z-index: 5;color: #fff;top: 60%;right: 0px;
      box-shadow: inset -5px -5px 20px #430017 !important;
      border-radius: 0px 12px !important;
     cursor:pointer;padding: 4px 0px 4px 7px;line-height: 12px;min-width: 110px;" 
     class="guideflap" @click="openSupport()" :style="'top:' + topPosition + '%'">
  <div id="mydivheader">
      <span style="display: inline-block;
    font-size: 12px;font-weight: bold;text-shadow: 2px 1px 4px #2c6436;
    text-align: left;vertical-align: sub;padding:1px 0px;">Have<br>Queries?</span>
        <span style="display: inline-block;
    font-size: 20px;padding-left: 4px;line-height: 4px;margin-right: 3px;">&#128172;</span>
 </div>
  </div>
  <b-modal
    v-model="openSupportModal"
    :centered="true"
    :no-close-on-backdrop="dontCloseWhenClickedOutside"
    :no-close-on-esc="dontCloseWhenEscapePressed"
    :hide-header-close="dontShowCloseIcon"
    :hide-footer="true"
    :hide-header="true"
    @cancel="eventCancel($event)"
    :size="'lg'"
  >
    <div class="empanel-modal-close" style="padding: 20px 10px !important;">     
      <span class="Modal-head-text" style="font-size: 20px;">Partner Support Form</span>
      <p class>
        <img
          @click="closeContactModal()"
          class="cursor-pointer modal-close-button mt-n1"
          style="float:right"
          src="@/assets/images/close1.svg"
        />
      </p>
    </div>
    <div class="row" style="padding:10px 30px;">
      <div class="col-12" style="padding:10px;font-weight:bold;font-size: 16px;">
        Name:
        <input class="form-control" maxlength="20" v-model="vendorName"
        style="height: 40px !important;font-size: 16px;"
         :disabled="disableEmail ? 'disabled': false"/>
      </div>    
      <div class="col-12" style="padding:10px;font-weight:bold;font-size: 16px;">
        Email id: <span v-if="!disableEmail">(OTP will be sent to this email id)</span>
        <input class="form-control" :disabled="disableEmail ? 'disabled': false"
         v-model="emailId" @input="getEmail()"
         style="height: 40px !important;font-size: 16px;"/>
         <div v-if="emailExists" style="font-weight: normal;padding: 2px 10px;
    font-size: 12px;color:#c31919;background: #ffe4e1;">
           Open chat with this email already exists kindly check existing email notifications to find link to the chat</div>
         <div v-if="restrictEmail"  style="font-weight: normal;padding: 2px 10px;
    font-size: 12px;color:#c31919;background: #ffe4e1;">
           Email id of this domain are not allowed. Kindly use helpdesk.</div>
      </div>  
      <div class="col-12" style="padding:10px;font-weight:bold;font-size: 16px;">
        Message Details: (max 500 characters)
        <textarea class="form-control" 
         v-model="message"
         maxlength="500" rows="5"/>
      </div>  
      <div style="padding:10px;display: inline-block;">
        <div style="display: inline-block;" v-if="disableEmail">
                <FileUploader 
                  :heading="'Attach documents if any (Not Mandatory)'"
                  @fileInputChange="UploadDocument($event, index)"
                />

                <ul style="list-style-type:disc;" v-if="attachmentFileId">
                  <li>
                    <a
                      @click="showAttachFile(attachmentFileId)"
                      href="#"
                      class="mt-n2"
                    >{{getFileName(attachmentFileId)}}</a>
                  </li>
                </ul></div>
                <div class="" style="display: inline-block;" >
                  
      <div class="">
                <div style="padding-left:20px;">
                <div v-if="!disableEmail" style="display: inline-block;">
                    <input type="number" class="form-control" style="
                      display: inline-block;margin-right:15px;
                      width: 110px;" v-if="otpSentToEmail && !emailOTPVerified"
                      v-model="emailOTP" @keypress="emailOTP = emailOTP.substring(0, 5)"
                      :placeholder="'Enter OTP'"/>
                    <button class="btn btn-primary" style="
                      display: inline-block; margin-right:15px;"
                      @click="sendOTPtoEmail()"
                      :class="!emailId || (emailExists || restrictEmail) || invalidEmailPattern 
                      ? 'disabled' : ''"
                      v-if="!otpSentToEmail && !emailOTPVerified">Send OTP to Email</button>
                      
                    <button class="btn btn-success"  style="
                      display: inline-block; margin-right:15px;"
                      v-if="otpSentToEmail && !emailOTPVerified"
                      @click="verifyEmailOTP()">Verify</button>
                      
                    <button class="btn btn-primary" style="
                      display: inline-block; margin-right:15px;"
                      v-if="otpSentToEmail && !emailOTPVerified && false">Re-Send OTP to Email</button>
                      <span style="color:#228b22 !important;font-weight:bold;"
                      v-if="emailOTPVerified"> &#10003; Email Verifed</span>

                </div>
        <button class="btn btn-success" @click="submitQuery()" style="margin: 0px auto;">Submit Query</button>
                </div>
              </div>

      </div>  
              </div> 
               
    </div>
    <w-loadingSpinner :loadSpinner="loading" />
  </b-modal>
  </div>
</template>

<script>
import loadingSpinner from "../widgets/LoadingSpinner";
import DropDown from "../widgets/DropDown";
import TextInput from "../widgets/TextInput";
import { PartnerService } from "../services/partnerService";
const partnerService = new PartnerService();
import { OnBoardingServices } from "../services/onBoardingService";
const OnBoardingService = new OnBoardingServices();
import widgetModal from "../widgets/newModalWidget";
import confirmationModal from "../widgets/confirmationModal";
import { RegistrationService } from "../services/RegistrationService.js";
const RegisterService = new RegistrationService();

import FileUploader from "../widgets/FileUploader.vue";
export default {
  components: {
    "w-dropdown": DropDown,
    "w-text-input": TextInput,
    "w-loadingSpinner": loadingSpinner,
    widgetModal,
    confirmationModal,
    FileUploader
  },
  props: [
    "trigger",
    "dontCloseWhenClickedOutside",
    "dontShowCloseIcon",
    "dontCloseWhenEscapePressed",
    "pId",
    "selectedCompanyCode" 
  ],
  data() {
    return {      
      attachmentFileId:'',
      siteUrl:'',
      openSupportModal:false,
      loading: false,
      vendorName:"",
      message:"", 
      emailId:'',
      topPosition: '65',
      otpSentToEmail:false,
      emailOTPVerified:false,
      invalidEmailPattern:true,
      emailOTP:'',
      emailExists: false,
      restrictEmail: false,     
      disableEmail: true
    };
  },
  
  watch: {
    openSupportModal: function(newVal, oldVal) {
      if (newVal != oldVal) {
      var eid = window.localStorage.getItem('eid')
      var partnerNumber = window.localStorage.getItem('partnerNumber')
      if(eid && eid.trim().length != 0) {
        this.emailId = window.atob(eid)
        this.vendorName = window.atob(partnerNumber)
        this.disableEmail = true
      } else {
        this.emailId = ''
        this.vendorName=''  
        this.disableEmail = false
      }
      this.message=''
      this.$root.$emit('resetfile')      
      this.emailExists = false;
      this.restrictEmail = false;
      this.emailOTPVerified = false;
      this.otpSentToEmail = false 
      this.attachmentFileId=''
      
      }
    }
  },
  created() {
    var self = this
    self.$root.$on('toppos', function(e){
        self.topPosition = e - 10
    })
  },
  mounted(){
    
//Make the DIV element draggagle:
dragElement(document.getElementById("mydiv"));

function dragElement(elmnt) {
  var pos1 = 0, pos2 = 0, pos3 = 0, pos4 = 0;
  if (document.getElementById(elmnt.id + "header")) {
    /* if present, the header is where you move the DIV from:*/
    document.getElementById(elmnt.id + "header").onmousedown = dragMouseDown;
  } else {
    /* otherwise, move the DIV from anywhere inside the DIV:*/
    elmnt.onmousedown = dragMouseDown;
  }

  function dragMouseDown(e) {
    e = e || window.event;
    e.preventDefault();
    // get the mouse cursor position at startup:
    pos3 = e.clientX;
    pos4 = e.clientY;
    document.onmouseup = closeDragElement;
    // call a function whenever the cursor moves:
    document.onmousemove = elementDrag;
  }

  function elementDrag(e) {
    e = e || window.event;
    e.preventDefault();
    // calculate the new cursor position:
    pos1 = pos3 - e.clientX;
    pos2 = pos4 - e.clientY;
    pos3 = e.clientX;
    pos4 = e.clientY;
    // set the element's new position:
    elmnt.style.top = (elmnt.offsetTop - pos2) + "px";
    elmnt.style.left = (elmnt.offsetLeft - pos1) + "px";
  }

  function closeDragElement() {
    /* stop moving when mouse button is released:*/
    document.onmouseup = null;
    document.onmousemove = null;
  }
}
  },
  methods: {
    openSupport(){
      this.openSupportModal=!this.openSupportModal
      var eid = window.localStorage.getItem('eid')
      if(eid && eid.trim().length != 0) {
        this.emailId = window.atob(eid)
        this.disableEmail = true
      } else {
        this.emailId = ''
        this.disableEmail = false
      }
    },
    EncodeUsingAES(value) {
      var CryptoJS = require("crypto-js");
      if (value === undefined || value === null) {
        return "";
      } else {
        const keys = atob(process.env.VUE_APP_E_K)
        const key = CryptoJS.enc.Utf8.parse(keys);
        const vectorIV = CryptoJS.enc.Utf8.parse(keys);
        const encrypted = CryptoJS.AES.encrypt(
          CryptoJS.enc.Utf8.parse(value.toString()),
          key,
          {
            keySize: 128 / 8,
            iv: vectorIV,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
          }
        );
        return encrypted.toString();
      }
    },
    verifyEmailOTP() {
      var self = this
      var data={
          "email": this.EncodeUsingAES(this.emailId),
          "referenceNumber": this.emailOTP,
          "smsCode": 3
          } 
          self.otpSentToEmail = true;
      RegisterService.emailOTPVerify(data).then(resp => {
        let res = resp.response;
        if(res) {
          self.emailOTPVerified = true;
        } else {
          window.alert(resp.failureMessage)
        }
      })
        .catch(error => {
          window.alert('Something went wrong! Please contact support.')
        });    
    },
    sendOTPtoEmail(){
      var self = this
      if(!self.emailId || (self.emailExists || self.restrictEmail) || self.invalidEmailPattern){
        window.alert('Kindly enter valid email.')
        return false
      }
      var data={
          "companyCode": 1,
          "payLoad": this.EncodeUsingAES(this.vendorName+'~~~'+this.emailId),
          "smsCode": 3
          }
      RegisterService.emailOTPsend(data).then(resp => {
        let res = resp.response;
        if(res.message=="OTP sent successfully"){
          window.alert("OTP has been sent to " + this.emailId + ". Kindly enter OTP and verify.")
          self.otpSentToEmail = true;
        } else {
          window.alert(resp.failureMessage)
        }
      })
        .catch(error => {
          window.alert('Something went wrong! Please contact support.')
        });
    
    },    
    UploadDocument(event,index,isReopen) {
      let data = new FormData();
      let file = event[0];
      // data.append("name", "my-file");
      data.append("file", file);
      this.loading = true;

      OnBoardingService.uploadAttachments(data)
        .then(resp => {
          if (resp) {
            this.loading = false;
            this.attachmentFileId = resp.UniqueID;
            this.siteUrl = resp.SiteUrl;
          } else{            
          this.triggerModal = true;
          this.loading = false;
          this.lastResponse = "Something went wrong. Try After Sometime";
          this.alertsuccess = true;
          }
        })
        .catch(error => {
          this.loading = false;
          this.triggerModal = true;
          this.lastResponse = " Try After Sometime";
          this.alertsuccess = true;
        });
    },
    getFileName(fileName) {
      if (fileName != null) {
        var fileNameFinal = null;
        fileNameFinal = fileName.split(/_(.+)/)[1];
        return fileNameFinal;
      }
      return fileNameFinal;
    },
    showAttachFile(event) {
      OnBoardingService.downLoadDocument(event).then(res => {});
    },
    getEmail() {
      this.emailExists = false;
      this.restrictEmail = false;
      this.emailOTPVerified = false;
      this.otpSentToEmail = false
      // this.form.email = event;
      this.emailId = this.emailId.toLowerCase();
      let emailRegex = new RegExp("^[a-zA-Z0-9+._-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,6}$");

      if (emailRegex.test(this.emailId.toLowerCase())) {
        this.invalidEmailPattern = false;       
       RegisterService.getAllPartnerQueryListWithEmail(this.emailId.toLowerCase()).then(resp => {
        let res = resp.response;
        if(resp.failureMessage == "No records found") {
          this.emailExists = false
        } else {
          this.emailExists = true
          //window.alert(resp.failureMessage)
        }
      })
        .catch(error => {
          window.alert('Something went wrong! Please contact support.')
        });   
        var domain = this.emailId.toLowerCase().replace(/.*@/, "");
        var domainName = domain.split(".");
        if (domainName[0]) {
          if(domainName[0].trim().toLowerCase()=='lntecc' || domainName[0].trim().toLowerCase()=='lntpower' ||
          domainName[0].trim().toLowerCase().indexOf('lnt') > -1) {
            this.restrictEmail = true
          }
        }
      } else {
        this.invalidEmailPattern = true;
      }
    },
    validateForm(){
      if(!this.disableEmail && !this.emailOTPVerified) {
         window.alert("Kindly verify Email OTP and try again")
        return false;
      }
       let emailRegex = new RegExp("^[a-zA-Z0-9+._-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,6}$");
       if (this.vendorName.trim().length < 3) {
        window.alert("Vendor Name must be atleast 3 characters long")
        return false;
      }  else if (this.emailId.trim().length < 1) {
        window.alert("Email Id cannot be empty")
        return false;
      } else if (!emailRegex.test(this.emailId.trim().toLowerCase())) {
        window.alert("Invalid email pattern")
        return false;
      } else if (this.message.trim().length < 50) {
        window.alert("Issue description must be atleast 50 characters long")
        return false;
      } else if(!(/^[A-Za-z0-9&-\s]*$/.test(this.vendorName))) {
        window.alert('vendorName name cannot contain special characters except & or -')        
        return false;
      } else {
        return true;
      }
    },
    submitQuery(){
      var self = this
      var data = {
        "partnerEmailId":this.emailId,
      "supportEmailId":"",
      "supportUserId":0,
      "displayName":this.vendorName,
      "message":this.message,
      "attachmentDocId":this.attachmentFileId,
      "siteUrl":this.siteUrl}

      if(this.validateForm()){
      RegisterService.savePartnerQuery(data,'origin').then(resp => {
        let res = resp.response;
        if(resp.failureMessage == "") {
          window.alert("Your query has been submitted please check email for updates on your query")
          self.openSupportModal = false;
        } else {
          window.alert(resp.failureMessage)
        }
      })
        .catch(error => {
          window.alert('Something went wrong! Please contact support.')
        });   
      }
    },
    closeContactModal() { 
      this.openSupportModal = false
    },
    closeConfirmModal() {
      this.triggerConfirmModal = false;
    }
  }
};
</script>

<style scoped>
.support-fly{
    top: 60%;
    right: -25px;
    position: fixed;
    z-index: 99;
    border: 2px solid #1a71ab;
    background: #fff;
    padding: 5px 25px 5px 10px;
    border-top-left-radius: 20px;
    border-bottom-left-radius: 20px;
    color: #1a71ab;
    font-size: 14px;
    font-weight: bold;
    cursor: pointer;
    box-shadow: 2px 2px 10px #000;
    transition: right 200ms;
}
.support-fly:hover{
    right: -5px;
}

.guideflap:hover{
      background: #045f51 !important;
}

#mydiv {
  position: absolute;
  z-index: 9;
  text-align: center;
}

</style>
